export interface PropertyCategoryItem {
  id: number;
  name: string;
  defaultRooms?: number;
  defaultFloor?: string;
  isLandOrPlot?: boolean;
  isGarage?: boolean;
}

/**
 * Всички категории (видове имоти) от платформата Estate Assistant (CRM)
 * Точно копие на системната номенклатура на платформата:
 */
export const ESTATE_ASSISTANT_CATEGORIES: PropertyCategoryItem[] = [
  { id: 29, name: '1-стаен', defaultRooms: 1 },
  { id: 28, name: '2-стаен', defaultRooms: 2 },
  { id: 32, name: '3-стаен', defaultRooms: 3 },
  { id: 34, name: '4-стаен', defaultRooms: 4 },
  { id: 27, name: 'Многостаен', defaultRooms: 5 },
  { id: 30, name: 'Мезонет', defaultRooms: 4 },
  { id: 35, name: 'Ателие, Таван', defaultRooms: 1 },
  { id: 36, name: 'Етаж от къща', defaultRooms: 3 },
  { id: 37, name: 'Къща', defaultRooms: 4 },
  { id: 38, name: 'Вила', defaultRooms: 3 },
  { id: 41, name: 'Офис', defaultRooms: 1 },
  { id: 33, name: 'Стая', defaultRooms: 1 },
  { id: 42, name: 'Магазин', defaultRooms: 1 },
  { id: 47, name: 'Заведение', defaultRooms: 1 },
  { id: 45, name: 'Сгради', defaultRooms: 0 },
  { id: 1001, name: 'Затворен комплекс', defaultRooms: 0 },
  { id: 44, name: 'Склад', defaultRooms: 0 },
  { id: 31, name: 'Гараж', defaultRooms: 0, defaultFloor: 'Партер', isGarage: true },
  { id: 48, name: 'Хотел', defaultRooms: 0 },
  { id: 40, name: 'Парцел', defaultRooms: 0, defaultFloor: 'Терен', isLandOrPlot: true },
  { id: 39, name: 'Земеделски имот', defaultRooms: 0, defaultFloor: 'Терен', isLandOrPlot: true },
  { id: 46, name: 'Инвест. проекти', defaultRooms: 0, defaultFloor: 'Терен', isLandOrPlot: true },
  { id: 43, name: 'Пром. помещение', defaultRooms: 0 }
];

export const ALL_PROPERTY_CATEGORY_NAMES: string[] = ESTATE_ASSISTANT_CATEGORIES.map(c => c.name);

/**
 * Помощна функция за намиране на категория по име
 */
export function findCategoryByName(name?: string): PropertyCategoryItem | undefined {
  if (!name) return undefined;
  const lower = name.trim().toLowerCase();
  return ESTATE_ASSISTANT_CATEGORIES.find(c => c.name.toLowerCase() === lower);
}
